import type { ReactNode } from "react";

export interface EyebrowProps {
  children: ReactNode;
  /** Rendert als <h2> statt <p>, wenn das Eyebrow der Abschnittstitel ist. */
  as?: "p" | "h2" | "h3";
  className?: string;
}

/**
 * Abschnittsmarke: kleiner Akzentpunkt plus versalgesetztes Label.
 *
 * Der Punkt ist laut Design-Dokument identitaetstragend und wird nie
 * weggelassen. Er ist reine Dekoration und daher aria-hidden -- vorgelesen wird
 * nur der Text.
 */
export function Eyebrow({ children, as: Tag = "p", className }: EyebrowProps): React.ReactElement {
  return (
    <Tag className={["eyebrow", className].filter(Boolean).join(" ")}>
      <span className="eyebrow__dot" aria-hidden="true" />
      {children}
    </Tag>
  );
}
